import { Component, Input, OnInit, signal, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

@Component({
    selector: 'app-medicationDetails',
    templateUrl: './medicationDetails.component.html',
    styleUrl: './medicationDetails.component.scss',
    standalone: false
})
export class MedicationDetailsComponent implements OnInit {
    displayedColumns: string[] = ['dateOfService', 'drugDescription', 'strengthName', 'drugType', 'daysSupply', 'metricQuantity', 'rxInstruction', 'pharmacyName', 'prescriberFullName', 'tier', 'claimStatusDescription', 'adjudicationDate'];
    dataSource = new MatTableDataSource<any>([]); @ViewChild(MatPaginator) paginator!: MatPaginator; @ViewChild(MatSort) sort!: MatSort; ngAfterViewInit() { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort; }
    @Input() medicationData: any;
    actualData: any;
    filterMode: string = "All";
    items:String[]=["All","Reversal","Non-Reversal"];
    initialLoadedalldata:any;
    async ngOnInit() {
        let filterWithReversalData = this.calculateReversals(this.medicationData);
        this.proccessData(filterWithReversalData);
        this.dataSource.data = this.actualData;
        this.actualData=await this.proccessData(filterWithReversalData);
        this.initialLoadedalldata= await this.proccessData(this.medicationData);
        this.dataSource.data = this.initialLoadedalldata
    }
    onChange(event:any) {
        let value =event.target.value;
        if (value == "All") {
            this.dataSource.data = this.initialLoadedalldata;
        } else if (value  == "Reversal") {
            this.dataSource.data = this.actualData.filter(data => data.Reversed);

        } else if (value  == "Non-Reversal") {
            this.dataSource.data = this.actualData.filter(data => data.Reversed != true);

        }

    }
    calculateReversals(list: any[]): any[] {
        if (!list || list.length === 0) {
            return [];
        }

        // clone to avoid mutating parent data
        const initialClaims = list
            .filter(i => !i.claimStatus || i.claimStatus.toUpperCase() !== "R")
            .map(i => ({ ...i }));

        const reversals = list.filter(i =>
            i.claimStatus && i.claimStatus.toUpperCase() === "R"
        );

        for (const item of initialClaims) {
            let reversal = reversals.find(i =>
                i.edwDataSource === item.edwDataSource &&
                i.pharmacyClaimNumber === item.pharmacyClaimNumber &&
                i.dateOfService === item.dateOfService &&
                i.pharmacyClaimAdjustedNumber === item.pharmacyClaimAdjustedNumber &&
                i.adjudicationDate === item.adjudicationDate
            );

            if (reversal) {
                item.Reversed = true;
                continue;
            }

            reversal = reversals.find(i =>
                i.edwDataSource === item.edwDataSource &&
                i.pharmacyClaimNumber === item.pharmacyClaimNumber &&
                i.dateOfService === item.dateOfService &&
                i.pharmacyClaimAdjustedNumber === item.pharmacyClaimAdjustedNumber
            );

            if (reversal) {
                const otherClaimCount = initialClaims.filter(i =>
                    i.edwDataSource !== item.edwDataSource &&
                    i.pharmacyClaimNumber === reversal.pharmacyClaimNumber &&
                    i.dateOfService === reversal.dateOfService &&
                    i.pharmacyClaimAdjustedNumber === reversal.pharmacyClaimAdjustedNumber &&
                    i.adjudicationDate === reversal.adjudicationDate
                ).length;

                if (otherClaimCount === 0) {
                    item.Reversed = true;
                }
            }
        }

        return initialClaims.sort((a, b) => {
            const ds = this.compareDesc(a.dateOfService, b.dateOfService);
            if (ds !== 0) return ds;

            const adjA = a.pharmacyClaimAdjustedNumber || '';
            const adjB = b.pharmacyClaimAdjustedNumber || '';
            const adj = adjA.localeCompare(adjB);
            if (adj !== 0) return adj;

            return this.compareAsc(a.adjudicationDate, b.adjudicationDate);
        });

    }

    compareAsc(a: any, b: any): number {
        return a < b ? -1 : a > b ? 1 : 0;
    }

    compareDesc(a: any, b: any): number {
        return a > b ? -1 : a < b ? 1 : 0;
    }
    async proccessData(medicationData: any) {
        let actualData = await medicationData.map(({
            dateOfService,
            drugDescription,
            strengthName, drugType,
            daysSupply, metricQuantity, rxInstruction,
            pharmacyName,
            prescriberFullName,
            tier,
            claimStatusDescription,
            adjudicationDate,
            Reversed }) => {

            return {
                dateOfService: this.formatDate(dateOfService),
                drugDescription,
                strengthName,
                drugType,
                daysSupply,
                metricQuantity,
                rxInstruction,
                pharmacyName,
                prescriberFullName,
                tier,
                claimStatusDescription,
                adjudicationDate: this.formatDate(adjudicationDate),
                Reversed
            }
        })
        return actualData;
    }
    formatDate(data:any){
       let spliteDate= data.split(" ");
       const [year,month,date]=spliteDate[0].split("-");
       return `${month}/${date}/${year}`;
    }
    applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}